"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WatchlistType = void 0;
/**
 * This file was generated and subsequently committed to source via TypescriptUserFacingStringsGenerator.
 * Do not modify this file directly. If updates are required, update the utility as necessary and re-run it.
 */
var WatchlistType;
(function (WatchlistType) {
    WatchlistType["ContractEmployee"] = "WATCHLIST_TYPE_CONTRACT_EMPLOYEE";
    WatchlistType["Custom"] = "WATCHLIST_TYPE_CUSTOM";
    WatchlistType["DepartingEmployee"] = "WATCHLIST_TYPE_DEPARTING_EMPLOYEE";
    WatchlistType["ElevatedAccessPrivileges"] = "WATCHLIST_TYPE_ELEVATED_ACCESS_PRIVILEGES";
    WatchlistType["FlightRisk"] = "WATCHLIST_TYPE_FLIGHT_RISK";
    WatchlistType["HighImpactEmployee"] = "WATCHLIST_TYPE_HIGH_IMPACT_EMPLOYEE";
    WatchlistType["NewEmployee"] = "WATCHLIST_TYPE_NEW_EMPLOYEE";
    WatchlistType["PerformanceConcerns"] = "WATCHLIST_TYPE_PERFORMANCE_CONCERNS";
    WatchlistType["PoorSecurityPractices"] = "WATCHLIST_TYPE_POOR_SECURITY_PRACTICES";
    WatchlistType["SuspiciousSystemActivity"] = "WATCHLIST_TYPE_SUSPICIOUS_SYSTEM_ACTIVITY";
})(WatchlistType = exports.WatchlistType || (exports.WatchlistType = {}));
